import { createServerFn } from "@tanstack/react-start";

import { authMiddleware } from "~/lib/auth-middleware";

interface UserPasswordStatus {
  hasPassword: boolean;
}

export const getUserPasswordStatus = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }): Promise<UserPasswordStatus> => {
    const clerkUserId = context.user.clerkUserId;

    if (!clerkUserId) {
      return { hasPassword: false };
    }

    const { clerkUserHasPassword } = await import("~/lib/server/clerk-server");

    try {
      return { hasPassword: await clerkUserHasPassword(clerkUserId) };
    } catch (error) {
      console.error("Failed to determine user password status", error);
      throw new Error("Unable to verify password status");
    }
  });
